import type { ContentCardModel } from "~/models/ContentCard";

export class ContentCardsModel {
  contents: ContentCardModel[];
  count: number;
  total: number;

  constructor(contents: ContentCardModel[] = [], total: number = 0) {
    this.contents = contents;
    this.count = contents.length;
    this.total = total;
  }

  addContent = (content: ContentCardModel) => {
    this.contents.push(content);
    this.count++;
  };

  addContents = (contents: ContentCardModel[]) => {
    this.contents.push(...contents);
    this.count += contents.length;
  };

  setTotalContennt = (total: number) => {
    this.total = total;
  };
}
